module.exports = __webpack_public_path__ + "img/mine_banner_particle.5af93fe8.png";